import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { useLocale } from "@/contexts/LocaleContext";
import { DICTS } from "@/lib/i18n";
import { PUBLIC_SITE_ORIGIN } from "@/lib/public-origin";

import { publicCacheHeaders } from "@/lib/public-cache-headers";

export const Route = createFileRoute("/privacy")({
  headers: publicCacheHeaders,
  head: () => ({
    meta: [
      { title: DICTS.en["legal.privacy.meta.title"] },
      { name: "description", content: DICTS.en["legal.privacy.meta.description"] },
      { property: "og:title", content: DICTS.en["legal.privacy.meta.title"] },
      { property: "og:description", content: DICTS.en["legal.privacy.meta.description"] },
      { property: "og:url", content: `${PUBLIC_SITE_ORIGIN}/privacy` },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: `${PUBLIC_SITE_ORIGIN}/privacy` }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  const { t } = useLocale();
  return (
    <LegalLayout titleKey="legal.privacy.title" eyebrowKey="legal.privacy.eyebrow">
      <p>{t("legal.privacy.intro")}</p>
      <h2>{t("legal.privacy.h2_collect")}</h2>
      <p>{t("legal.privacy.p_collect")}</p>
      <h2>{t("legal.privacy.h2_processors")}</h2>
      <p>{t("legal.privacy.p_processors")}</p>
      <h2>{t("legal.privacy.h2_cookies")}</h2>
      <p>{t("legal.privacy.p_cookies")}</p>
      <h2>{t("legal.privacy.h2_rights")}</h2>
      <p>{t("legal.privacy.p_rights")}</p>
      <h2>{t("legal.privacy.h2_whatsapp")}</h2>
      <p>{t("legal.privacy.p_whatsapp")}</p>
      <h2>{t("legal.privacy.h2_retention")}</h2>
      <p>{t("legal.privacy.p_retention")}</p>
    </LegalLayout>
  );
}
